import Api from './BusinessProfile.api';
import { message } from 'antd';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { BusinessProfileConstants } from './BusinessProfile.constants';
import actions from 'redux/User/actions';
import { t } from 'i18next';
import { getAccountDetails } from 'redux/UserManagement/UserManagement.action';

const BusinessProfile = new Api('services/', 'account');
const auth = new Api('services', 'auth');

// --- Error Handller
const handleError = error => {
  const statusFirstDigit = error && (error.status / 100) >> 0;

  if (statusFirstDigit === 4 || statusFirstDigit === 5) {
    if (error.response && error.response.data && error.response.data.detail) {
      message.error(error.response.data.detail);
    } else {
      message.error(t('GRAAS_SOMETHING_WENT_WRONG_GRAAS'));
    }
  }
};

export const updateBusinessProfileDetails = (payload, isReloadLinkedAccount, type, action) => {
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await BusinessProfile.updateBusinessProfileDetails(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: BusinessProfileConstants.UPDATE_BUSINESS_PROFILE_SUCCESS, payload: data });
        if (payload?.status === 'X') {
          if (data?.response === 'success') {
            message.success(t('GRAAS_THIS_PROFILE_DELETED_SUCCESSFULLY_GRAAS'));
           dispatch(getAccountDetails()) 
          } else {
            message.error(payload?.profileNickNameValue + ' ' + data?.responseMessage);
          }
        } else if (data?.response === 'warning') {
          message.error(data?.responseMessage);
        } else if (type !== '' && action !== '') {
          message.success(t(type + '_successfully_' + action.toLowerCase()));
        }
        if (isReloadLinkedAccount) {
          dispatch({ type: actions.GET_ACCOUNT_DETAILS });
          
        }
        // after profile update need to load address details list
        dispatch(getLinkedAddressList());
        dispatch(getLinkedProfileList());
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};
export const getLinkedProfileList = () => {
  let apiData = {};
  let errorObj = {};
  return async dispatch => {
    dispatch({ type: BusinessProfileConstants.GET_LINKED_PROFILE_LIST_REQUEST });
    try {
      apiData = await BusinessProfile.getLinkedProfileList();
      if (apiData && apiData.hasError) {
        errorObj = apiData.error;
        throw new Error();
      } else {
        dispatch({ type: BusinessProfileConstants.GET_LINKED_PROFILE_LIST_SUCCESS, payload: apiData });
      }
    } catch (error) {
      handleError(errorObj);
      dispatch({ type: BusinessProfileConstants.GET_LINKED_PROFILE_LIST_FAILED });
    }
  };
};
export const getLinkedAddressList = () => {
  let apiData = {};
  let errorObj = {};
  return async dispatch => {
    dispatch({ type: BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_REQUEST });
    try {
      apiData = await BusinessProfile.getLinkedAddressList();
      if (apiData && apiData.hasError) {
        errorObj = apiData.error;
        throw new Error();
      } else {
        dispatch({ type: BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_SUCCESS, payload: apiData });
      }
    } catch (error) {
      handleError(errorObj);
      dispatch({ type: BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_FAILED });
    }
  };
};

export const onCreateUser = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.onCreateUser(payload);
      if (apiData && apiData.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const onUpdateUser = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.onUpdateUser(payload);
      if (apiData && apiData.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const onDeleteUser = userId => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.onDeleteUser(userId);
      if (apiData && apiData.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const updateBusinessPassword = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await auth.updateBusinessPassword(payload);
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const onUpdateUserMenuPermissions = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.onUpdateUserMenuPermissions(payload);
      if (apiData && apiData.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const updateBusinessUserMessagingPreference = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.updateBusinessUserMessagingPreference(payload);
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const getBusinessAccountSettings = () => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.getBusinessAccountSettings();
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const getBusinessUserMessagingPreference = () => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.getBusinessUserMessagingPreference();
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const updateBusinessAccountSettings = payload => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.updateBusinessAccountSettings(payload);
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const getLinkedAccountDetails = channel => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.getLinkedAccountDetails(channel);
      if (apiData && apiData.hasError) {
        errorObj = apiData.error;
        throw new Error();
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};

export const initiateGoogle = (payload) => {
  let apiData = {};
  let errorObj = {};
  return async () => {
    try {
      apiData = await BusinessProfile.initiateGoogle(payload);
     
      if (apiData && apiData?.hasError) {
        errorObj = apiData?.error;
        throw new Error();
      } else {
        return apiData;
      }
    } catch (error) {
      return errorObj;
    }
  };
};
